import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { PreloaderIcon } from 'theme/icons';

const styles = theme => ({
	root: {
		width: '100%',
		height: '100%'
	},
	preloader: {
		display: 'block',
		width: '300px',
		height: '300px',
		position: 'absolute',
		top: 'calc(50% - 150px)',
		left: 'calc(50% - 150px)'
	}
});

@withStyles(styles)
class Preloader extends Component {

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<div className={classes.preloader}>
					<PreloaderIcon />
				</div>
			</div>
		);
	}

}

Preloader.propTypes = {
	classes: PropTypes.object
};

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/Preloader/Preloader.js